import { useState, useEffect } from "react";
import { Table, Button, Container, Alert, Badge } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

export default function Deactivate() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchActiveProducts();
  }, []);

  const fetchActiveProducts = () => {
    setLoading(true);
    fetch("http://localhost:4000/products/active")
      .then((res) => res.json())
      .then((data) => {
        setProducts(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching products:", error);
        setLoading(false);
        Swal.fire("Error", "Failed to fetch products", "error");
      });
  };

  const handleDeactivate = (productId, productName) => {
    Swal.fire({
      title: "Are you sure?",
      text: `This will deactivate "${productName}". You can reactivate it later.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, deactivate it!",
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`http://localhost:4000/products/${productId}/archive`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({}),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data === true) {
              Swal.fire("Deactivated!", "Product has been deactivated.", "success");
              fetchActiveProducts(); // Refresh the list
            } else {
              Swal.fire("Error", "Failed to deactivate product", "error");
            }
          })
          .catch((error) => {
            console.error("Error deactivating product:", error);
            Swal.fire("Error", "Failed to deactivate product", "error");
          });
      }
    });
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Deactivate Products</h1>
        <Button variant="secondary" onClick={() => navigate("/admin")}>
          Back to Admin
        </Button>
      </div>

      {loading ? (
        <Alert variant="info">Loading active products...</Alert>
      ) : products.length === 0 ? (
        <Alert variant="warning">No active products found.</Alert>
      ) : (
        <>
          <Alert variant="info">
            <strong>Note:</strong> Deactivating a product will hide it from customers but won't delete it permanently.
            You can reactivate products later from the Activate Products page.
          </Alert>

          <Table striped bordered hover responsive>
            <thead>
              <tr>
                <th>Product Name</th>
                <th>Description</th>
                <th>Price</th>
                <th>Status</th>
                <th>Created On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {products.map((product) => (
                <tr key={product._id}>
                  <td>{product.name}</td>
                  <td>{product.description}</td>
                  <td>₱{product.price}</td>
                  <td>
                    <Badge bg="success">Active</Badge>
                  </td>
                  <td>{new Date(product.createdOn).toLocaleDateString()}</td>
                  <td>
                    <Button
                      variant="warning"
                      size="sm"
                      onClick={() => handleDeactivate(product._id, product.name)}
                    >
                      Deactivate
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </Container>
  );
}